import { render, staticRenderFns } from "./downloads-drawer.vue?vue&type=template&id=24dd771e&"
import script from "./downloads-drawer.vue?vue&type=script&lang=js&"
export * from "./downloads-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports